<template>
    <div class="o-dashboard">
        <c-table class="o-dashboard__table-accounts"
            :columns="columns"
            :placeholder="'Zoek op naam of E-mailadres'"
            :endpoint="'/api/accounts/'"
            :key="'table-in-progress'"></c-table>
    </div>
</template>

<script>
import CTable from '@components/table/Container';
import View from '@mixins/View';

export default {
	components: { CTable },
	mixins: [ View ],
    computed: {
        columns() {
            return [
                { name: 'name', label: 'Naam' },
                { name: 'email', label: 'E-mail' },
                { name: 'created_at', label: 'Account aangemaakt op', component: 'CColumnDatetime' },
                { name: 'email_verified', label: 'Actief', component: 'CColumnBoolean' },
                { name: 'email_verified_at', label: 'Actief sinds', component: 'CColumnDatetime', sort: true }
            ]
        }
    }
}
</script>
